// colorHelper.js

export function getColorClasses(accessor) {
  switch (accessor) {
    case 'collections':
      return {
        backgroundColor: 'bg-amber-500/15',
        textColor: 'text-amber-900',
        accentBorder: 'border-l-amber-500',
        ringColor: 'ring-amber-400/30',
      };
    case 'reciprocals':
      return {
        backgroundColor: 'bg-emerald-500/15',
        textColor: 'text-emerald-900',
        accentBorder: 'border-l-emerald-500',
        ringColor: 'ring-emerald-400/30',
      };
    case 'combined_designer_original':
      return {
        backgroundColor: 'bg-emerald-500/15',
        textColor: 'text-emerald-900',
        accentBorder: 'border-l-emerald-500',
        ringColor: 'ring-emerald-400/30',
      };
    case 'designer_contributor':
      return {
        backgroundColor: 'bg-indigo-500/15',
        textColor: 'text-indigo-900',
        accentBorder: 'border-l-indigo-500',
        ringColor: 'ring-indigo-400/30',
      };
    case 'reciprocals_clean.domestic_reciprocals':
      return {
        backgroundColor: 'bg-indigo-500/15',
        textColor: 'text-indigo-900',
        accentBorder: 'border-l-indigo-500',
        ringColor: 'ring-indigo-400/30',
      };
    case 'green_fees.concessions_accepted':
    case 'green_fees.bundle_tickets':
      return {
        backgroundColor: 'bg-rose-500/15',
        textColor: 'text-rose-900',
        accentBorder: 'border-l-rose-500',
        ringColor: 'ring-rose-400/30',
      };
    default:
      return {
        backgroundColor: 'bg-slate-500/10',
        textColor: 'text-slate-800',
        accentBorder: 'border-l-slate-500',
        ringColor: 'ring-slate-400/30',
      };
  }
}
